import { InstructionComponentProps } from "../InstructionComponent"
import IMG_1 from "../../../resources/tutorial/DOOR_IOS_8.png"
import IMG_2 from "../../../resources/tutorial/DOOR_IOS_9.png"
import IMG_3 from "../../../resources/tutorial/OuraConnect_Step3.png"
import IMG_4 from "../../../resources/tutorial/DOOR_IOS_10.png"
import ImageTextComponent from "../../ImageTextComponent"

const OuraConnectInstructions: InstructionComponentProps = {
    name: "Wie verbinde ich meinen Oura-Ring mit der DOOR Studie Connect App?",
    path: "/help/patient/oura_connect",
    description:
        "Um den Oura-Ring mit der DOOR Studie Connect App zu verbinden, ist es notwendig, dass Sie den Oura-Ring bereits eingerichtet haben.",
    both: [
        <ImageTextComponent
            text={
                <>
                    <strong style={{ fontSize: '1.2em', color: '#1f2937' }}>
                        WICHTIGER HINWEIS: Das Studienteam richtet normalerweise die Oura-Verbindung bereits für Sie ein!
                    </strong>
                    <br /><br />
                    Falls Sie in den Einstellungen den "Oura Login" Knopf sehen, haben Sie zwei Möglichkeiten:
                    <br /><br />
                    <strong>Möglichkeit 1 (empfohlen):</strong> Kontaktieren Sie das Studienteam unter door-hilfe@kl.cit.tum.de oder +49 89 954 5391 78. Das Studienteam kann die Verbindung von zu Hause aus und sehr einfach für Sie einrichten. Es ist kein persönlicher Termin erforderlich.
                    <br /><br />
                    <strong>Möglichkeit 2:</strong> Falls Sie sich mit Setup Prozessen auskennen, können Sie die Verbindung auch selbst herstellen (siehe Schritte unten).
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                    Navigieren Sie in der DOOR Studie App zu den Einstellungen,
                    indem Sie auf das kleine Zahnrad in der untereren rechten
                    Ecke klicken. Nach einem Klick auf "Oura Login" werden Sie
                    auf die Oura-Login Seite weitergeleitet.
                </>
            }
            images={[IMG_1]}
        />,
        <ImageTextComponent
            text={
                <>
                    Melden Sie sich hier mit den gleichen Anmeldedaten an, die Sie auch für DOOR Studie Connect verwenden. 
                    Diese wurden Ihnen vom Studienteam zur Verfügung gestellt. 
                    Stimmen Sie danach durch einen Klick auf den
                     &#34;Accept&#34; Knopf zu, dass DOOR Studie Connect auf Ihre
                    Oura-Daten zugreifen darf. Somit werden die Daten vom Ring an die DOOR Studie Connect App übertragen, und von dort an Ihren behandelnden Arzt. 
                    Klicken Sie dann auf "Öffnen" um zurück zur App zu gelangen.
                </>
            }
            images={[IMG_3, IMG_2]}
        />,
        <ImageTextComponent
            text={
                <>
                    Nachdem Sie der Datenübertragung zugestimmt haben, wird Ihr
                    Oura-Ring mit der DOOR Studie Connect App verbunden. Wenn Sie
                    das Feld 'Ringverbindung trennen' sehen können, war die Verbindung erfolgreich.
                    Sollte dies in der App nicht angezeigt werden, schliessen sie einmal die App und öffnen sie diese erneut. Dann sollte die Verbindung hergestellt sein.
                </>
            }
            images={[IMG_4]}
        />
    ]
}

export default OuraConnectInstructions
